<template>
  <div class="configurations">
    <div class="configurations-navbar">
      <breadcrumb-view :items="breadcrumb"></breadcrumb-view>

      <principal-bar
        title="Configurations"
        :buttonsList="buttonsList"
      ></principal-bar>

    </div>
    <simple-table
      :data="dataTable"
      :firstColumn="firstColumn"
      :intervals="intervals"
      :loading="loading"
      :searchText="'Filter Configuration'"
      :showSearch="true"
      :tableColumns="columns"
      @searchRow="searchData"
      @viewRow="viewData"
      @handleSingleBackup="handleSingleBackup"
      class="container"
    ></simple-table>

    <simple-paginator
      @currentChange="currentChange"
      @sizeChange="sizeChange"
      :currentPage="paginator.currentPage"
      :pageSize="paginator.pageSize"
      :total="paginator.total"
      :pagerCount="5"
      layout="total, sizes, prev, pager, next, jumper"
      class="container"
    ></simple-paginator>

    <configuration-modal
      v-if="showModalCreate"
      :showModal="showModalCreate"
      :state="state"
      :id="dataId"
      :title="title">
    </configuration-modal>

    <view-modal
      v-if="showModalView"
      :showModal="showModalView"
      :data="dataItem"
      :intervals="intervals"
    >
    </view-modal>
  </div>
</template>

<script>

import { mapState, mapGetters } from 'vuex';
import ApiBACKUPS from '@/lib/ApiBACKUPS';
import Utils from '@/lib/Utils';
import SimpleTable from '@/components/Tables/SimpleTable.vue';
import PrincipalBar from '@/components/Bars/PrincipalBar.vue';
import ConfigurationModal from '@/components/Modals/configurations/ConfigurationModal.vue';
import ViewModal from '@/components/Modals/ViewModal.vue';
import BreadcrumbView from '@/components/Bars/BreadcrumbView.vue';
import SimplePaginator from '@/components/Paginator/SimplePaginator.vue';

export default {
  name: 'BackupsList',
  components: {
    BreadcrumbView,
    ViewModal,
    ConfigurationModal,
    SimpleTable,
    PrincipalBar,
    SimplePaginator,
  },
  props: ['brandId'],
  data() {
    return {
      Utils,
      buttonsList: [
        {
          text: 'Create New',
          actionType: 'showModalCreate',
          icon: 'mdi-plus',
        },
      ],
      intervals: {
        5: '5 Minutes',
        30: '30 Minutes',
        60: '1 Hour',
        120: '2 Hour',
        180: '3 Hour',
        240: '4 Hour',
        300: '5 Hour',
        360: '6 Hour',
        720: '12 Hour',
        1440: '24 Hour',
      },
      loading: true,
      showModalCreate: false,
      showModalEdit: false,
      showModalView: false,
      dataTable: [],
      dataItem: {},
      brand: {},
      state: 'create',
      title: 'New Configuration',
      dataId: null,
      breadcrumb: [
        {
          string: 'Configurations List',
          active: true,
        },
      ],
      columns: [
        {
          prop: 'name',
          label: 'Database Name',
          sortable: false,
        },
        {
          prop: 'actions',
          label: 'Actions',
          sortable: false,
          isActions: true,
          typeButtons: 'links',
          buttons: [],
        },
        {
          prop: 'admin',
          label: 'Admin',
          sortable: false,
          isActions: true,
          typeButtons: 'icons',
          dropdown: [],
        },
      ],
      firstColumn: {
        show: true,
        icon: 'mdi-chart-box-outline',
      },
      paginator: {
        currentPage: 0,
        pageSize: 10,
        total: 0,
        page: 1,
      },
    };
  },
  computed: {
    ...mapState(['user']),
    ...mapGetters(['isValidPermission']),
    brandName() {
      const { brand } = this;
      const result = brand.name;
      return result;
    },
  },
  methods: {
    async handleSingleBackup(configurationId) {
      const response = await ApiBACKUPS.post('/backup', {
        configurationId,
      });

      if (response.success) {
        return this.$message({
          showClose: true,
          message: 'Backups generated correctly',
          type: 'success',
        });
      }

      return this.$message({
        showClose: true,
        message: response.error,
        type: 'warning',
      });
    },
    getAll(search = null) {
      this.dataTable = [];
      this.loading = true;
      const paginate = `page_size=${this.paginator.pageSize}&page=${this.paginator.page}`;

      let url = `/backups/list?${paginate}`;

      if (search) {
        url = `/backups/list?${paginate}&search=${search}`;
      }
      ApiBACKUPS.get(url).then((r) => {
        this.dataTable = Object.values(r.data);
        if (r.paginator.total_pages) {
          this.paginator.currentPage = r.paginator.page;
          this.paginator.page_size = r.paginator.page_size;
          this.paginator.total = r.paginator.count;
        }
        this.loading = false;
      }).catch((e) => {
        console.log(e);
        this.loading = false;
      });
    },
    closeModal() {
      this.showModalView = false;
      this.showModalEdit = false;
      this.showModalCreate = false;
    },
    openModalCreate() {
      this.showModalCreate = true;
      this.state = 'create';
      this.title = 'New Configuration';
    },
    viewData(row) {
      this.dataItem = row;
      this.showModalView = true;
    },
    editData(data) {
      if (data.type === 'Configurations' || data.type === 'Home') {
        this.showModalCreate = true;
        this.state = 'update';
        this.title = 'Update Configuration';
        this.dataId = data.id;
      }
    },
    async hideDataSource(id) {
      try {
        const r = await ApiBACKUPS.put(`/configurations/${id}`, { enabled: true });
        if (r.success) {
          this.getAll();
        }
      } catch (error) {
        console.error(error);
      }
    },
    async deleteDataSource(id) {
      try {
        const r = await ApiBACKUPS.delete(`/configurations/${id}`);
        if (r.success) {
          this.getAll();
        }
      } catch (error) {
        console.error(error);
      }
    },
    searchData(string) {
      this.getAll(string);
    },
    validatePermissions() {
      let actions = '';

      actions = this.columns.findIndex((btn) => btn.prop === 'actions');
      this.columns[actions].buttons.push({
        text: 'View',
        action: 'view',
      });

      actions = this.columns.findIndex((btn) => btn.prop === 'admin');
      this.columns[actions].dropdown.push({
        text: 'Edit',
        action: 'edit',
      });

      // actions = this.columns.findIndex((btn) => btn.prop === 'admin');
      // this.columns[actions].dropdown.push({
      //   text: 'Hide',
      //   action: 'hide',
      // });

      // actions = this.columns.findIndex((btn) => btn.prop === 'admin');
      // this.columns[actions].dropdown.push({
      //   text: 'Delete',
      //   action: 'delete',
      // });
    },
    currentChange(val) {
      this.paginator.page = val;
      this.getAll();
    },
    sizeChange(val) {
      this.paginator.pageSize = val;
      this.paginator.handlesSizeChange = true;
      this.getAll();
    },
  },
  async mounted() {
    this.getAll();

    this.$root.$on('closeModal', this.closeModal);
    this.$root.$on('openModalCreate', this.openModalCreate);
    this.$root.$on('reloadData', this.getAll);

    // TABLE EMITS
    this.$root.$on('editRow', this.editData);
    this.$root.$on('hideRow', this.hideDataSource);
    this.$root.$on('deleteRow', this.deleteDataSource);

    this.validatePermissions();
  },
};
</script>

<style lang="scss">

  .configurations-navbar{
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: auto ;
  background: rgba(63, 181, 229, 0.08);
  height: 145px;
  align-content: center;
  padding: 0 30px;

  @media (min-width: 720px){
    padding: 0 90px;
    grid-template-rows: auto;
    grid-template-columns: auto auto ;
  }

  .principal-bar{
    justify-self: end;
    column-gap: 10px !important;
    @media (min-width: 720px){
      column-gap: 20px;
    }

    .title{
      display: block;
      @media (min-width: 720px){
        display: none;
      }

      h1{
        font-size: 20px;
      }
    }
  }

}
</style>
